export default "__VITE_ASSET__e8f86ee9__"